<template>
    <div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">HS</label>
                        <div class="col-sm-9">
                            <v-select :options="fetchHsCode" v-model="HsCode" return-object @search="searchHsCode"
                                :filter-by="hsCodeSearch" @input="changeHsCode" label="hs_code">

                                <template slot="option" slot-scope="option">
                                    {{ option.hs_code + " - " + option.uraian }}
                                </template>

                                <template slot="selected-option" slot-scope="option">
                                    {{ option.hs_code + " - " + option.uraian }}
                                </template>
                            </v-select>

                            <div v-if="errors.hsCode">
                                <div v-for="error in errors.hsCode" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Lartas</label>
                        <div class="col-sm-9">
                            <div v-show="isLartas !== null">
                                <div class="alert alert-warning" role="alert" v-show="isLartas">
                                    <i data-feather="alert-circle"></i>
                                    HS Terkena Lartas
                                </div>
                                <div class="alert alert-success" role="alert" v-show="!isLartas">
                                    <i data-feather="check-circle"></i>
                                    Bukan Lartas
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Pernyataan Lartas</label>
                        <div class="col-sm-9">
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" name="pernyataanLartas"
                                    v-model="formsBarang.pernyataanLartas" value="Y" :id="this.$dynamicId()">
                                <label class="form-check-label">
                                    Terkena Lartas
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" name="pernyataanLartas"
                                    v-model="formsBarang.pernyataanLartas" value="T" :id="this.$dynamicId()">
                                <label class="form-check-label">
                                    Tidak Terkena Lartas
                                </label>
                            </div>

                            <div v-if="errors.pernyataanLartas">
                                <div v-for="error in errors.pernyataanLartas" :key="error" class="alert alert-primary"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Kode</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" :id="this.$dynamicId()" v-model="formsBarang.kode"
                                @input="forceUpper($event, formsBarang, 'kode')">

                            <div v-if="errors.kode">
                                <div v-for="error in errors.kode" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Uraian </label>
                        <div class="col-sm-6">
                            <textarea class="form-control" v-model="formsBarang.uraian" :id="this.$dynamicId()"
                                @input="forceUpper($event, formsBarang, 'uraian')"></textarea>

                            <div v-if="errors.uraian">
                                <div v-for="error in errors.uraian" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                        <div class="col-sm-3">
                            <button class="btn btn-twitter" @click.prevent="addUraianHs">Sesuai HS</button>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Merk</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="formsBarang.merk" :id="this.$dynamicId()"
                                @input="forceUpper($event, formsBarang, 'merk')">

                            <div v-if="errors.merk">
                                <div v-for="error in errors.merk" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Tipe</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="formsBarang.tipe" :id="this.$dynamicId()"
                                @input="forceUpper($event, formsBarang, 'tipe')">

                            <div v-if="errors.tipe">
                                <div v-for="error in errors.tipe" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Ukuran</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="formsBarang.ukuran" :id="this.$dynamicId()"
                                @input="forceUpper($event, formsBarang, 'ukuran')">

                            <div v-if="errors.ukuran">
                                <div v-for="error in errors.ukuran" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Spesifikasi Lain</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="formsBarang.spesifikasiLain"
                                @input="forceUpper($event, formsBarang, 'spesifikasiLain')" :id="this.$dynamicId()">

                            <div v-if="errors.spesifikasiLain">
                                <div v-for="error in errors.spesifikasiLain" :key="error" class="alert alert-primary"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Kondisi Barang</label>
                        <div class="col-sm-9">
                            <v-select :options="fetchKondisiBarang" v-model="kondisiBarang" label="label"
                                return-object></v-select>

                            <div v-if="errors.kodeKondisiBarang">
                                <div v-for="error in errors.kodeKondisiBarang" :key="error" class="alert alert-primary"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Negara</label>
                        <div class="col-sm-9">
                            <v-select :options="fetchNegaraAsal" v-model="negaraAsal" @search="searchNegaraAsal"
                                :filter-by="customSearch" label="code"
                                return-object>
                                <template slot="option" slot-scope="option">
                                    {{ option.code + " - " + option.name }}
                                </template>

                                <template slot="selected-option" slot-scope="option">
                                    {{ option.code + " - " + option.name }}
                                </template>
                            </v-select>

                            <div v-if="errors.kodeNegaraAsal">
                                <div v-for="error in errors.kodeNegaraAsal" :key="error" class="alert alert-primary"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Berat Bersih</label>
                        <div class="col-sm-9">

                            <vue-number class="form-control" v-model="formsBarang.netto"
                                v-bind="formatDecimal"></vue-number>


                            <div v-if="errors.netto">
                                <div v-for="error in errors.netto" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="col-md-6">

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Satuan</label>
                        <div class="col-sm-4">
                            <vue-number class="form-control" v-model="formsBarang.jumlahSatuan"
                                v-bind="formatDecimal"></vue-number>

                            <div v-if="errors.jumlahSatuan">
                                <div v-for="error in errors.jumlahSatuan" :key="error" class="alert alert-primary"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>
                            <!-- <input type="number" class="form-control" :id="this.$dynamicId()" v-model.number="satuanDisplay"> -->
                        </div>
                        <div class="col-sm-5">
                            <v-select :options="fetchSatuan" @search="searchSatuanBarang" v-model="satuanBarang"
                                label="code" return-object :filter-by="customSearch">
                                <template slot="option" slot-scope="option">
                                    {{ option.code + " - " + option.name }}
                                </template>

                                <template slot="selected-option" slot-scope="option">
                                    {{ option.code + " - " + option.name }}
                                </template>
                            </v-select>

                            <div v-if="errors.kodeSatuanBarang">
                                <div v-for="error in errors.kodeSatuanBarang" :key="error" class="alert alert-primary"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Kemasan</label>
                        <div class="col-sm-4">
                            <vue-number class="form-control" v-model="formsBarang.jumlahKemasan"
                                v-bind="formatDecimal"></vue-number>

                            <div v-if="errors.jumlahKemasan">
                                <div v-for="error in errors.jumlahKemasan" :key="error" class="alert alert-primary"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>


                        </div>
                        <div class="col-sm-5">
                            <v-select :options="fetchKemasan" @search="searchKemasanBarang" v-model="kemasanBarang"
                                label="code" return-object :filter-by="customSearch">

                                <template slot="option" slot-scope="option">
                                    {{ option.code + " - " + option.name }}
                                </template>

                                <template slot="selected-option" slot-scope="option">
                                    {{ option.code + " - " + option.name }}
                                </template>
                            </v-select>

                            <div v-if="errors.kodeJenisKemasan">
                                <div v-for="error in errors.kodeJenisKemasan" :key="error" class="alert alert-primary"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Amount</label>
                        <div class="col-sm-9">
                            <vue-number class="form-control" v-model="formsBarang.nilaiBarang"
                                v-bind="formatDecimal"></vue-number>

                            <div v-if="errors.nilaiBarang">
                                <div v-for="error in errors.nilaiBarang" :key="error" class="alert alert-primary"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">(Biaya Tambahan - Diskon)</label>
                        <div class="col-sm-9">
                            <!-- <input type="number" readonly v-model.number="formsBarang.nilaiBayar" class="form-control"
                                :id="this.$dynamicId()"> -->
                            <vue-number readonly class="form-control" :value="biayaPengurang"
                                v-bind="formatDecimal"></vue-number>

                            <div v-if="errors.nilaiBayar">
                                <div v-for="error in errors.nilaiBayar" :key="error" class="alert alert-primary"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">FOB</label>
                        <div class="col-sm-9">
                            <vue-number readonly class="form-control" :value="fob" v-bind="formatDecimal"></vue-number>
                            <div v-if="errors.fob">
                                <div v-for="error in errors.fob" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Harga Satuan</label>
                        <div class="col-sm-9">
                            <vue-number readonly class="form-control" :value="hargaSatuan"
                                v-bind="formatDecimal"></vue-number>
                            <div v-if="errors.hargaSatuan">
                                <div v-for="error in errors.hargaSatuan" :key="error" class="alert alert-primary"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Freight</label>
                        <div class="col-sm-9">
                            <!-- <input type="number" readonly v-model.number="formsBarang.freight" class="form-control"
                                :id="this.$dynamicId()"> -->
                            <vue-number class="form-control" readonly :value="freight" v-bind="formatDecimal"></vue-number>

                            <div v-if="errors.freight">
                                <div v-for="error in errors.freight" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Asuransi</label>
                        <div class="col-sm-9">
                            <!-- <input type="number" readonly v-model.number="formsBarang.asuransi" class="form-control"
                                :id="this.$dynamicId()"> -->

                            <vue-number class="form-control" readonly :value="asuransi" v-bind="formatDecimal"></vue-number>

                            <div v-if="errors.asuransi">
                                <div v-for="error in errors.asuransi" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">CIF</label>
                        <div class="col-sm-9">
                            <!-- <input type="number" readonly v-model.number="formsBarang.cif" class="form-control"
                                :id="this.$dynamicId()"> -->
                            <vue-number class="form-control" readonly :value="cif" v-bind="formatDecimal"></vue-number>
                            <div v-if="errors.cif">
                                <div v-for="error in errors.cif" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">CIF Rupiah</label>
                        <div class="col-sm-9">
                            <!-- <input type="number" readonly v-model.number="formsBarang.cifRupiah" class="form-control"
                                :id="this.$dynamicId()"> -->
                            <vue-number class="form-control" readonly :value="cifRupiah"
                                v-bind="formatDecimal"></vue-number>
                            <div v-if="errors.cifRupiah">
                                <div v-for="error in errors.cifRupiah" :key="error" class="alert alert-primary"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <div class="card">
                    <div class="card-header">
                        <h6 class="card-title float-start">Dokumen Fasilitas / Lartas</h6>
                        <button class="btn btn-primary float-end btn-sm" @click="addRowFasilitas">Add</button>
                    </div>
                    <div class="card-body">
                        <vue-good-table title="list-dokumen-fasilitas" :rows="rowsDokumenFasilitas"
                            :columns="columnFasilitas" :line-numbers="true">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">

                                    <a href="#" title="Delete" @click.prevent="removeRowFasilitas(props.index)">
                                        <i class="mdi mdi-delete-forever" style="font-size:16px;color:red;"></i>

                                    </a>
                                </span>

                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <div class="card">
                    <div class="card-header">
                        <h6 class="card-title float-start">Jenis Transaksi</h6>
                        <button class="btn btn-primary float-end btn-sm" @click="addRowTransaksi">Add</button>
                    </div>
                    <div class="card-body">
                        <vue-good-table title="list-transaksi" :rows="rowsTransaksi" :columns="columnTransaksi"
                            :line-numbers="true">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">

                                    <a href="#" title="Delete" @click.prevent="removeRowTransaksi(props.index)">
                                        <i class="mdi mdi-delete-forever" style="font-size:16px;color:red;"></i>

                                    </a>
                                </span>

                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="card">
                    <div class="card-header">
                        <h6 class="card-title float-start">Spek Khusus</h6>
                        <button class="btn btn-primary float-end btn-sm" @click="addRowSpekKhusus">Add</button>
                    </div>
                    <div class="card-body">
                        <vue-good-table title="list-transaksi" :rows="rowsSpekKhusus" :columns="columnSpekKhusus"

                            :line-numbers="true">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">

                                    <a href="#" title="Delete" @click.prevent="removeRowSpekKhusus(props.index)">
                                        <i class="mdi mdi-delete-forever" style="font-size:16px;color:red;"></i>

                                    </a>
                                </span>

                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="card">
                    <div class="card-header">
                        <h6 class="card-title float-start">Pungutan</h6>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="card">
                                <div class="card-header">
                                    <h6 class="card-title float-start">BM</h6>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-3" v-show="isBm">
                                        <div class="col-md-2">
                                            <label class="form-label">Jenis Pungutan</label>
                                            <v-select :options="fetchJenisPungutan" :placeholder="'Jenis Pungutan'"
                                                v-model="jenisPungutanBm" return-object label="label"></v-select>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label">Jenis Tarif</label>
                                            <v-select :options="fetchJenisTariff" v-model="jenisTarifBm" label="label"
                                                :placeholder="'Jenis Tarif'" return-object></v-select>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label">Tarif</label>
                                            <vue-number class="form-control" v-model="formsPungutan.tarifBm"
                                                v-bind="formatPercentage"></vue-number>

                                            <!-- <input type="number" class="form-control" :id="this.$dynamicId()" step=".01"
                        v-model.number="formsPungutan.tarif" maxlength="255" /> -->
                                        </div>
                                        <div class="col-md-4">
                                            <label class="form-label">Jenis Fasilitas Tarif</label>
                                            <v-select :options="fetchJenisFasilitas" v-model="jenisFasilitasBm"
                                                @input="updateTariff($event, formsPungutan, 'tarifFasilitasbm')"
                                                label="label" :placeholder="'Jenis Fasilitas Tarif'"
                                                return-object></v-select>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label">Tarif Fasilitas</label>
                                            <vue-number class="form-control" v-model="formsPungutan.tarifFasilitasbm"
                                                :readonly="jenisFasilitasBm?.code == '1'"
                                                v-bind="formatPercentage"></vue-number>

                                            <!-- <input type="number" class="form-control" :id="this.$dynamicId()" step=".01"
                        v-model.number="formsPungutan.tarifFasilitas" maxlength="255" /> -->
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="row mb-3">
                            <div class="card">
                                <div class="card-header">
                                    <h6 class="card-title float-start">BMT</h6>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-3" v-show="isBmAd">
                                        <div class="col-md-2">
                                            <label class="form-label">BMAD</label>
                                            <div class="form-check">
                                                <label class="form-check-label">
                                                    <input type="checkbox" v-model="formsPungutan.checkBMAD"
                                                        class="form-check-input">
                                                    Sementara
                                                    <i class="input-frame"></i></label>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label">Jenis Tarif</label>
                                            <v-select :options="fetchJenisTariff" v-model="jenisTarifBmAd" label="label"
                                                :placeholder="'Jenis Tarif'" return-object></v-select>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label">Tarif</label>
                                            <vue-number class="form-control" v-model="formsPungutan.tarifAd"
                                                v-bind="formatPercentage"></vue-number>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="form-label">Jenis Fasilitas Tarif</label>
                                            <v-select :options="fetchJenisFasilitas" v-model="jenisFasilitasBmAd"
                                                @input="updateTariff($event, formsPungutan, 'tarifFasilitasAd')"
                                                label="label" :placeholder="'Jenis Fasilitas Tarif'"
                                                return-object></v-select>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label">Tarif Fasilitas</label>
                                            <vue-number class="form-control" v-model="formsPungutan.tarifFasilitasAd"
                                                :readonly="jenisFasilitasBmAd?.code == '1'"
                                                v-bind="formatPercentage"></vue-number>
                                        </div>
                                    </div>
                                    <div class="row mb-3" v-show="isBmTp">
                                        <div class="col-md-2">
                                            <label class="form-label">BMTP</label>
                                            <div class="form-check">
                                                <label class="form-check-label">
                                                    <input type="checkbox" v-model="formsPungutan.checkBMTP"
                                                        class="form-check-input">
                                                    Sementara
                                                    <i class="input-frame"></i></label>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label">Jenis Tarif</label>
                                            <v-select :options="fetchJenisTariff" v-model="jenisTarifBmTp" label="label"
                                                :placeholder="'Jenis Tarif'" return-object></v-select>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label">Tarif</label>
                                            <vue-number class="form-control" v-model="formsPungutan.tarifTp"
                                                v-bind="formatPercentage"></vue-number>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="form-label">Jenis Fasilitas Tarif</label>
                                            <v-select :options="fetchJenisFasilitas" v-model="jenisFasilitasBmTp"
                                                @input="updateTariff($event, formsPungutan, 'tarifFasilitasTp')"
                                                label="label" :placeholder="'Jenis Fasilitas Tarif'"
                                                return-object></v-select>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label">Tarif Fasilitas</label>
                                            <vue-number class="form-control" v-model="formsPungutan.tarifFasilitasTp"
                                                :readonly="jenisFasilitasBmTp?.code == '1'"
                                                v-bind="formatPercentage"></vue-number>
                                        </div>
                                    </div>
                                    <div class="row mb-3" v-show="isBmIm">
                                        <div class="col-md-2">
                                            <label class="form-label">BMIM</label>
                                            <div class="form-check">
                                                <label class="form-check-label">
                                                    <input type="checkbox" v-model="formsPungutan.checkBMIM"
                                                        class="form-check-input">
                                                    Sementara
                                                    <i class="input-frame"></i></label>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label">Jenis Tarif</label>
                                            <v-select :options="fetchJenisTariff" v-model="jenisTarifBmIm" label="label"
                                                :placeholder="'Jenis Tarif'" return-object></v-select>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label">Tarif</label>
                                            <vue-number class="form-control" v-model="formsPungutan.tarifIm"
                                                v-bind="formatPercentage"></vue-number>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="form-label">Jenis Fasilitas Tarif</label>
                                            <v-select :options="fetchJenisFasilitas" v-model="jenisFasilitasBmIm"
                                                @input="updateTariff($event, formsPungutan, 'tarifFasilitasIm')"
                                                label="label" :placeholder="'Jenis Fasilitas Tarif'"
                                                return-object></v-select>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="form-label">Tarif Fasilitas</label>
                                            <vue-number class="form-control" v-model="formsPungutan.tarifFasilitasIm"
                                                :readonly="jenisFasilitasBmIm?.code == '1'"
                                                v-bind="formatPercentage"></vue-number>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div class="row mb-3">
                            <div class="card">
                                <div class="card-header">
                                    <h6 class="card-title float-start">PDRI</h6>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-3">
                                        <label class="col-sm-3 col-form-label">PPN</label>
                                        <div class="col-sm-3">
                                            <vue-number class="form-control" v-model="formsPungutan.tariffPpn"
                                                v-bind="formatPercentage"></vue-number>
                                        </div>
                                        <div class="col-sm-3">
                                            <v-select :options="fetchJenisFasilitas" v-model="jenisFasilitasPpn"
                                                @input="updateTariff($event, formsPungutan, 'tariffFasilitasPpn')"
                                                label="label" return-object></v-select>
                                        </div>
                                        <div class="col-sm-3">
                                            <!-- <input type="number" v-model.number="formsPungutan.tariffFasilitasPpn" class="form-control"
                        :id="this.$dynamicId()"> -->

                                            <vue-number class="form-control" v-model="formsPungutan.tariffFasilitasPpn"
                                                :readonly="jenisFasilitasPpn?.code == '1'"
                                                v-bind="formatPercentage"></vue-number>

                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <label class="col-sm-3 col-form-label">PPH</label>
                                        <div class="col-sm-3">
                                            <vue-number class="form-control" v-model="formsPungutan.tariffPph"
                                                v-bind="formatPercentage"></vue-number>
                                        </div>
                                        <div class="col-sm-3">
                                            <v-select :options="fetchJenisFasilitas" v-model="jenisFasilitasPph"
                                                @input="updateTariff($event, formsPungutan, 'tariffFasilitasPph')"
                                                label="label" return-object></v-select>
                                        </div>
                                        <div class="col-sm-3">
                                            <vue-number class="form-control" :readonly="jenisFasilitasPph?.code == '1'"
                                                v-model="formsPungutan.tariffFasilitasPph"
                                                v-bind="formatPercentage"></vue-number>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="row mb-3">
                            <div class="card">
                                <div class="card-header">
                                    <div class="form-check mb-2">
                                        <input type="checkbox" class="form-check-input" v-model="isCukai"
                                            :id="this.$dynamicId()">
                                        <h6 class="card-title float-start form-check-label">Cukai</h6>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row" v-show="isCukai">
                                        <div class="col-md-6">
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="row mb-3">
                                                        <div class="mb-3">
                                                            <label class="form-label text-danger">Komoditi</label>
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <v-select :options="fetchKomoditiCukai"
                                                                        v-model="komoditiCukai" label="label"
                                                                        return-object></v-select>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <input type="text" class="form-control"
                                                                        :id="this.$dynamicId()">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                        <div class="mb-3">
                                                            <label class="form-label">Jenis Tarif</label>
                                                            <v-select :options="fetchJenisTariff" v-model="jenisTarifCukai"
                                                                label="label" return-object></v-select>

                                                        </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                        <div class="mb-3">
                                                            <label class="form-label">Besar Tarif</label>
                                                            <vue-number class="form-control"
                                                                v-model="formsBarang.tarifCukai"
                                                                v-bind="formatDecimal"></vue-number>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                        <div class="mb-3">
                                                            <label class="form-label">Jumlah</label>
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <vue-number class="form-control"
                                                                        v-model="formsBarang.jumlahSatuanCukai"
                                                                        v-bind="formatDecimal"></vue-number>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <v-select :options="fetchSatuan" v-model="satuanCukai"
                                                                        label="label" @seach="searchSatuanBarang"
                                                                        return-object></v-select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                        <div class="mb-3">
                                                            <label class="form-label">Nilai Cukai</label>
                                                            <vue-number class="form-control"
                                                                v-model="formsBarang.nilaiCukai"
                                                                v-bind="formatDecimal"></vue-number>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                        <div class="mb-3">
                                                            <label class="form-label">Jenis Tarif</label>
                                                            <v-select :options="fetchJenisFasilitas"
                                                                v-model="jenisFasilitasCukai" @search="searchSatuanBarang"
                                                                label="label" return-object></v-select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="row mb-3">
                                                        <label class="form-label">HJE RP</label>

                                                        <vue-number class="form-control" v-model="formsBarang.hjeCukai"
                                                            v-bind="formatDecimal"></vue-number>

                                                    </div>
                                                    <div class="row mb-3">
                                                        <div class="mb-3">
                                                            <label class="form-label">Satuan Kemasan</label>
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <vue-number class="form-control"
                                                                        v-model="formsBarang.kemasanCukai"
                                                                        v-bind="formatDecimal"></vue-number>

                                                                </div>
                                                                <div class="col-md-6">
                                                                    <v-select :options="fetchKemasan" v-model="kemasanCukai"
                                                                        label="label" @search="searchKemasanBarang"
                                                                        return-object></v-select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                        <div class="mb-3">
                                                            <label class="form-label">Isi Per Kemasan</label>
                                                            <vue-number class="form-control"
                                                                v-model="formsBarang.isiPerKemasan"
                                                                v-bind="formatDecimal"></vue-number>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                        <div class="mb-3">
                                                            <label class="form-label">Jumlah Pita Cukai</label>
                                                            <vue-number class="form-control"
                                                                v-model="formsBarang.jumlahPitaCukai"
                                                                v-bind="formatDecimal"></vue-number>

                                                        </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                        <div class="mb-3">
                                                            <label class="form-label">Saldo Awal</label>
                                                            <vue-number class="form-control" v-model="formsBarang.saldoAwal"
                                                                v-bind="formatDecimal"></vue-number>

                                                        </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                        <div class="mb-3">
                                                            <label class="form-label">Saldo Akhir</label>
                                                            <vue-number class="form-control"
                                                                v-model="formsBarang.saldoAkhir"
                                                                v-bind="formatDecimal"></vue-number>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">

                    <button class="btn btn-info float-end btn-sm" @click="submitData()" type="button" :disabled="isLoading"> 
                        <div v-show="isLoading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...
                        </div>
                        <div v-show="!isLoading">
                        <i class="link-icon mdi mdi-content-save"></i>
                        {{ $t("save_change_txt") + " " + $t('barang_txt') }}
                        </div>
                    </button>

                    <button class="btn btn-warning float-start btn-sm" @click="showForm()" type="button">
                        <i class="link-icon mdi mdi-arrow-left"></i>
                        {{ $t("backMess") }}
                    </button>

                </div>
            </div>
        </div>

        <modalDocumentFasilitas :propsData="documents" @closeModal="closeDocumentFasilitas"></modalDocumentFasilitas>
        <modalJenisTransaksi @closeModal="closeJenisTransaksi"></modalJenisTransaksi>
        <modalSpekKhusus @closeModal="closeSpekKhusus"></modalSpekKhusus>
        <!-- <button @click="showForm">Table</button> -->
    </div>
</template>

<script>
import modalDocumentFasilitas from "@/components/exim/ceisa/barang_impor/modal/modalDocumentListFasilitas.vue"
import modalJenisTransaksi from "@/components/exim/ceisa/barang_impor/modal/modalJenisTransaksi.vue"
import modalSpekKhusus from "@/components/exim/ceisa/barang_impor/modal/modalSpekKhusus.vue"
import { component as VueNumber } from '@coders-tm/vue-number-format'
export default {
    name: "BarangForm",
    components: {
        modalDocumentFasilitas,
        modalJenisTransaksi,
        modalSpekKhusus,
        VueNumber
    },
    props: {
        propsData: { type: [Object, Array] },
        propsBarang: { type: [Object, Array] },
        formType: { type: [String] },
    },
    data() {
        return {

            formatDecimal: {
                "separator": ",",
                "decimal": ".",
                "precision": 2,
                "nullValue": "0",
                "minimumFractionDigits": 2,
                "prefill": false
            },

            formatPercentage: {
                "separator": ".",
                "suffix": "%",
                "nullValue": "0",
                "precision": 2,
                "max": 100,
                "min": 0,
                "prefill": false
            },



            rowsDokumenFasilitas: [],
            columnFasilitas: [
                {
                    label: "Seri",
                    field: 'seriDokumen',
                    type: 'text',
                    thClass: 'text-center',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        trigger: "enter", //only trigger on enter not on keyup

                    },
                },
                {
                    label: "Jenis",
                    field: 'document',
                    type: 'text',
                    thClass: 'text-center',
                },
                {
                    label: "Nomor",
                    field: 'nomorDokumen',
                    type: 'text',
                    thClass: 'text-center',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        trigger: "enter", //only trigger on enter not on keyup

                    },
                },
                {
                    label: "Tanggal",
                    field: 'tanggalDokumen',
                    type: 'text',
                    thClass: 'text-center',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Fasilitas",
                    field: 'fasilitas',
                    type: 'text',
                    thClass: 'text-center',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Izin",
                    field: 'deskripsiIjin',
                    type: 'text',
                    thClass: 'text-center',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "File",
                    field: 'file',
                    type: 'text',
                    thClass: 'text-center',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Action",
                    field: 'actions',
                },
            ],
            rowsTransaksi: [],
            columnTransaksi: [
                {
                    label: "Jenis Transaksi",
                    field: 'jenisTransaksi',
                    type: 'text',
                    thClass: 'text-center',
                },
                {
                    label: "Jatuh Tempo Royalti",
                    field: 'jatuhTempo',
                    type: 'text',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Nilai Barang Vd",
                    field: 'nilaiBarangVd',
                    type: 'text',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Action",
                    field: 'actions',
                    type: 'text',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
            ],
            rowsSpekKhusus: [],
            columnSpekKhusus: [
                {
                    label: "Spek Khusus",
                    field: 'spekKhusus',
                    type: 'text',
                    thClass: 'text-center',
                },
                {
                    label: "Uraian",
                    field: 'uraianSpekKhusus',
                    type: 'text',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                
                {
                    label: "Action",
                    field: 'actions',
                    type: 'text',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
            ],
            forms: [],
            documents: [],

            fetchJenis: [],
            fetchJenisBm: [],
            jenisNilai: null,

            fetchHsCode: [],
            HsCode: null,

            fetchKondisiBarang: [],
            kondisiBarang: null,

            fetchNegaraAsal: [],
            negaraAsal: null,

            fetchSatuan: [],
            satuanBarang: null,
            satuanCukai: null,

            fetchKemasan: [],
            kemasanBarang: null,
            kemasanCukai: null,

            formsBarang: {
                jumlahSatuan: 0,
                jumlahKemasan: 0,
                nilaiBarang: 0,

                kemasanCukai: 0,
                nilaiCukai: 0,
                jumlahSatuanCukai: 0,
                tarifCukai: 0,
                isiPerKemasan: 0,
                jumlahPitaCukai: 0,
                saldoAwal: 0,
                saldoAkhir: 0,
                hjeCukai: 0,

                netto: 0,

                cif: 0,
                cifRupiah: 0,
                freight: 0,
                asuransi: 0,


            },
            formsPungutan: {
                tarifBm: 0,
                tarifAd: 0,
                tarifTp: 0,
                tarifIm: 0,
                tarifFasilitasbm: 0,
                tariffPpn: 0,
                tariffPph: 0,
                tariffFasilitasPpn: 0,
                tariffFasilitasPph: 100,
                tarifFasilitasAd: 0,
                tarifFasilitasTp: 0,
                tarifFasilitasIm: 0,
                checkBMAD: false,
                checkBMTP: false,
                checkBMIM: false,

            },

            fetchJenisPungutan: [
                { "code": "BM", "name": "BM", "label": "BM" },
                { "code": "BMKITE", "name": "BMKITE", "label": "BMKITE" },
            ],
            jenisPungutanBm: null,

            fetchJenisTariff: [
                { "code": "1", "name": "Advalorum", "label": "1 - Advalorum" },
                { "code": "2", "name": "Spesifik", "label": "2 - Spesifik" },
            ],
            jenisTarifBm: null,
            jenisTarifCukai: null,
            jenisTarifBmAd: null,
            jenisTarifBmTp: null,
            jenisTarifBmIm: null,

            fetchJenisFasilitas: [],
            jenisFasilitasBm: null,
            jenisFasilitasPpn: null,
            jenisFasilitasPph: { "code": "1", "name": "DIBAYAR", "label": "1 - DIBAYAR" },
            jenisFasilitasCukai: null,
            jenisFasilitasBmAd: null,
            jenisFasilitasBmTp: null,
            jenisFasilitasBmIm: null,


            fetchKomoditiCukai: [],
            komoditiCukai: null,

            isUpdate: false,

            isLartas: null,

            isCukai: false,
            isBm: false,
            isBmAd: false,
            isBmTp: false,
            isBmIm: false,

            isLoading: false,
            errors: {},
        }
    },
    methods: {
        customSearch(option, label, search) {
            let temp = search.toLowerCase();
            return option.code.toLowerCase().indexOf(temp) > -1 ||
                option.name.toLowerCase().indexOf(temp) > -1
        },
        hsCodeSearch(option, label, search) {
            let temp = search.toLowerCase();
            return option.hs_code.toLowerCase().indexOf(temp) > -1 ||
                option.uraian.toLowerCase().indexOf(temp) > -1 ||
                option.hs_code_format.toString().toLowerCase().indexOf(temp) > -1
        },
        forceUpper(e, obj, prop) {
            const start = e.target.selectionStart
            e.target.value = e.target.value.toUpperCase()
            this.$set(obj, prop, e.target.value)
            e.target.setSelectionRange(start, start)
        },
        updateTariff(ev, obj, name) {
            if (ev.code == "1" || ev.code == '2') {
                this.$set(obj, name, 100);
            }
        },
        changeHsCode(ev) {
            this.isBm = false;
            if (ev) {

                let hsDetail = JSON.parse(ev.detail);

                if (hsDetail) {
                    this.checkLartas(hsDetail);
                    console.log(hsDetail?.mfn[0]);

                    // Empty Pungutan
                    this.isBmAd = false;
                    this.jenisTarifBmAd = null;
                    this.jenisFasilitasBmAd = null;
                    this.$set(this.formsPungutan, "tarifAd", 0);
                    this.$set(this.formsPungutan, "checkBMAD", false);
                    this.$set(this.formsPungutan, "tarifFasilitasAd", 0);

                    this.isBm = false;
                    this.jenisTarifBm = null;
                    this.jenisPungutanBm = null;
                    this.jenisFasilitasBm = null;
                    this.$set(this.formsPungutan, "tarifBm", 0);

                    this.isBmTp = false;
                    this.jenisTarifBmTp = null;
                    this.jenisFasilitasBmTp = null;
                    this.$set(this.formsPungutan, "tarifTp", 0);
                    this.$set(this.formsPungutan, "checkBMTP", false);
                    this.$set(this.formsPungutan, "tarifFasilitasTp", 0);

                    this.isBmIm = false;
                    this.jenisTarifBmIm = null;
                    this.jenisFasilitasBmIm = null;
                    this.$set(this.formsPungutan, "tarifIm", 0);
                    this.$set(this.formsPungutan, "checkBMIM", false);
                    this.$set(this.formsPungutan, "tarifFasilitasIm", 0);

                    let bm = hsDetail?.mfn[0]?.bm;
                    if (bm.length > 0) {
                        if (bm[0].bm !== "N/A") {
                            this.isBm = true;
                            this.jenisPungutanBm = { "code": "BM", "name": "BM", "label": "BM" };
                            this.jenisTarifBm = { "code": "1", "name": "Advalorum", "label": "1 - Advalorum" };
                            this.$set(this.formsPungutan, "tarifBm", bm[0].bm);

                        }
                    }

                    let ad = hsDetail?.mfn[0]?.ad;
                    if (ad.length > 0) {
                        if (ad[0].ad !== "N/A") {
                            this.isBmAd = true;
                            this.jenisTarifBmAd = { "code": "1", "name": "Advalorum", "label": "1 - Advalorum" };
                            this.$set(this.formsPungutan, "tarifAd", ad[0].ad);

                        }
                    }

                    let tp = hsDetail?.mfn[0]?.tp;
                    if (tp.length > 0) {
                        if (tp[0].tp !== "N/A") {
                            this.isBmTp = true;
                            this.jenisTarifBmTp = { "code": "1", "name": "Advalorum", "label": "1 - Advalorum" };
                            this.$set(this.formsPungutan, "tarifAd", tp[0].tp);

                        }
                    }
                    let im = hsDetail?.mfn[0]?.im;
                    if (im.length > 0) {
                        if (im[0].im !== "N/A") {
                            this.isBmIm = true;
                            this.jenisTarifBmIm = { "code": "1", "name": "Advalorum", "label": "1 - Advalorum" };
                            this.$set(this.formsPungutan, "tarifIm", im[0].im);

                        }
                    }

                    let pph = hsDetail?.mfn[0]?.pph;

                    if (pph.length > 0) {
                        if (pph[0].pph !== "N/A") {
                            this.formsPungutan.tariffPph = pph[0].pph;
                        }
                    }

                    let ppn = hsDetail?.mfn[0]?.ppn;

                    if (ppn.length > 0) {
                        if (ppn[0].ppn !== "N/A") {
                            this.formsPungutan.tariffPpn = ppn[0].ppn;
                        }
                    }
                } else {
                    this.hsCode = null;
                    this.error("Empty Detail")
                }

            }
        },
        checkLartas(detail) {
            if (detail) {
                if (detail.import_regulation_border.length == 0 && detail.import_regulation_post_border.length == 0 && detail.import_regulation.length == 0) {
                    this.isLartas = false;
                    this.formsBarang.pernyataanLartas = "T";
                } else {
                    this.formsBarang.pernyataanLartas = "N";
                    this.isLartas = true;
                }
            }
        },
        addUraianHs() {
            this.$set(this.formsBarang, "uraian", this.HsCode?.uraian);
        },

        asyncKomoditi() {
            this.fetchKomoditiCukai = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=100&page=1&type=komoditiCukai&status=active";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {
                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchKomoditiCukai.push(md);

                        }
                    }
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asyncFasilitas() {
            this.fetchJenisFasilitas = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=100&page=1&sort_field=code&sort_type=ASC&type=fasilitasTarif&status=active";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {
                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchJenisFasilitas.push(md);

                        }
                    }
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asyncHsCode() {
            this.fetchHsCode = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/hs-code?hsCodeValid=true&limit=30";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {
                    this.fetchHsCode = response.data.datas.data;
                    // var models = response.data.datas.data;

                    // if (models.length > 0) {
                    //     for (var x = 0; x < models.length; x++) {

                    //         var ob = models[x];
                    //         var md = ob;
                    //         md.label = ob.hs_code + " - " + ob.uraian;
                    //         this.fetchHsCode.push(md);

                    //     }
                    // }

                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        searchHsCode(ev, loading) {
            loading(true);
            this.fetchHsCode = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/hs-code?hsCodeValid=true&limit=30&keyword=" + ev;

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {
                    loading(false);
                    var resp = response.data.datas.data;
                    this.fetchHsCode = resp;

                }).catch(error => {
                    loading(false);
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asyncNegaraAsal() {
            this.fetchNegaraAsal = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=20&page=1&type=kodeNegara&status=active";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {
                    this.fetchNegaraAsal = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        searchNegaraAsal(ev,loading){
            loading(true);
            this.fetchNegaraAsal = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=20&page=1&type=kodeNegara&status=active&keyword=" + ev;

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {
                    loading(false);
                    this.fetchNegaraAsal = response.data.datas.data;
                   
                }).catch(error => {
                    loading(false);
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asyncKondisiBarang() {
            this.fetchKondisiBarang = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=100&page=1&sort_field=code&sort_type=ASC&type=kodeKondisiBarang&status=active";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {
                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchKondisiBarang.push(md);

                        }
                    }
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asyncSatuanBarang() {
            this.fetchSatuan = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=50&type=kodeSatuanBarang&status=active";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {
                    this.fetchSatuan = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        searchSatuanBarang(ev, loading) {
            loading(true);
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=50&type=kodeSatuanBarang&status=active&keyword=" + ev;
            this.fetchSatuan = [];

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {
                    loading(false);
                    this.fetchSatuan = response.data.datas.data;
                }).catch(error => {
                    loading(false);

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });

        },
        asyncKemasanBarang() {
            this.fetchKemasan = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=50&type=kodeJenisKemasan&status=active";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {
                    this.fetchKemasan = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        searchKemasanBarang(ev, loading) {
            loading(true);
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=50&type=kodeJenisKemasan&status=active&keyword=" + ev;
            this.fetchKemasan = [];

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {
                    loading(false);
                    this.fetchKemasan = response.data.datas.data;
                }).catch(error => {
                    loading(false);

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });

        },

        closeDocumentFasilitas(val) {
            if (val.length > 0) {
                for (var x = 0; x < val.length; x++) {
                    var ob = val[x];
                    var check = this.checkDokumenFasilitas(ob);

                    if (check) {
                        this.rowsDokumenFasilitas.push({
                            "document_dokumen_id": ob.document_dokumen_id,
                            "document_id": ob.document_id,
                            "document": ob.kodeDokumen + " - " + ob.namaDokumen,
                            "fasilitas": ob.kodeFasilitas + " - " + ob.namaFasilitas,
                            "deskripsiIjin": ob?.izin ? ob.izin : "",
                            "nomorDokumen": ob.nomorDokumen,
                            "tanggalDokumen": ob.tanggalDokumen,
                            "seriDokumen": ob.seriDokumen,
                            "urlDokumen": ob.urlDokumen,
                        })
                    }
                }
            }
        },
        checkDokumenFasilitas(ev) {
            var res = true;
            if (this.rowsDokumenFasilitas.length > 0) {
                for (var x = 0; x < this.rowsDokumenFasilitas.length; x++) {
                    var obj = this.rowsDokumenFasilitas[x];

                    if (obj.document_dokumen_id == ev.document_dokumen_id) {
                        this.error("Duplicate Document " + ev.kodeDokumen + " - " + ev.namaDokumen);
                        res = false;
                    }
                }
            }
            return res;
        },
        closeJenisTransaksi(val) {
            console.log(val);
            var check = this.checkJenisTransaksi(val);
            if (check) {
                var code = val?.jenisNilai?.code ? val.jenisNilai.code : "";
                var name = val?.jenisNilai?.name ? val.jenisNilai.name : "";
                this.rowsTransaksi.push({
                    kodeJenisVd: code,
                    namaJenisVd: name,
                    jenisTransaksi: code + " - " + name,
                    jatuhTempo: val?.jatuhTempo,
                    nilaiBarangVd: val?.nilaiBarangVd,
                });
            }
        },
        checkJenisTransaksi(ev) {
            var res = true;
            if (this.rowsTransaksi.length > 0) {
                for (var x = 0; x < this.rowsTransaksi.length; x++) {
                    var obj = this.rowsTransaksi[x];

                    if (obj.kodeJenisVd == ev?.jenisNilai?.code) {
                        this.error("Duplicate Jenis VD " + ev.jenisNilai.code);
                        res = false;
                    }
                }
            }
            return res;
        },
        checkSpekKhusus(ev) {
            var res = true;
            if (this.rowsSpekKhusus.length > 0) {
                for (var x = 0; x < this.rowsSpekKhusus.length; x++) {
                    var obj = this.rowsSpekKhusus[x];

                    if (obj.kodeSpekKhusus == ev?.spekKhusus?.code) {
                        this.error("Duplicate Spek Khusus " + ev.spekKhusus.code);
                        res = false;
                    }
                }
            }
            return res;
        },
        closeSpekKhusus(val) {
            console.log(val);   
            var check = this.checkJenisTransaksi(val);
            if (check) {
                var code = val?.spekKhusus?.code ? val.spekKhusus.code : "";
                var name = val?.spekKhusus?.name ? val.spekKhusus.name : "";
                this.rowsSpekKhusus.push({
                    kodeSpekKhusus:code,
                    namaSpekKhusus:name,
                    spekKhusus: code + " - "+name,
                    uraianSpekKhusus:val?.uraian
                });
            }
        },
        countPercentageCif(val) {
            let cifRupiah = this.cifRupiah;

            var a = 0;
            if (cifRupiah !== 0 && val >= 0) {
                a = parseFloat(cifRupiah) * parseFloat(val / 100);
            }
            return a;
        },
        submitData() {
            this.isLoading = true;
            var send = {};
            send = this.formsBarang;

            send.document_id = this.forms.document_id;

            send.kodeJenisKemasan = this.kemasanBarang?.code;
            send.namaJenisKemasan = this.kemasanBarang?.name;

            send.kodeKondisiBarang = this.kondisiBarang?.code;
            send.namaKondisiBarang = this.kondisiBarang?.name;

            send.kodeNegaraAsal = this.negaraAsal?.code;
            send.namaNegaraAsal = this.negaraAsal?.name;

            send.kodeSatuanBarang = this.satuanBarang?.code;
            send.namaSatuanBarang = this.satuanBarang?.name;

            send.hsCode = this.HsCode?.hs_code_format;
            send.hsCodeUraian = this.HsCode?.uraian;

            send.fob = this.fob.toFixed(2);
            send.hargaSatuan = this.hargaSatuan.toFixed(2);
            send.cif = this.cif.toFixed(2);
            send.cifRupiah = this.cifRupiah.toFixed(2);
            send.freight = this.freight.toFixed(2);
            send.asuransi = this.asuransi.toFixed(2);
            send.ndpbm = this.forms.ndpbm;
            send.bruto = this.forms.bruto;
            send.diskon = this.biayaPengurang.toFixed(2);

            send.flagLantas = this.isLartas ? 1 : 0;

            // send.cif = 0;
            send.hargaEkspor = 0;
            send.hargaPatokan = 0;
            send.hargaPenyerahan = 0;
            send.hargaPerolehan = 0;
            send.jumlahBahanBaku = 0;
            send.jumlahDilekatkan = 0;
            send.jumlahRealisasi = 0;
            send.kapasitasSilinder = 0;
            send.volume = 0;
            send.nilaiDanaSawit = 0;
            send.nilaiDevisa = 0;
            send.nilaiTambah = 0;
            send.persentaseImpor = 0;
            send.seriBarangDokAsal = 0;
            send.seriIjin = 0;
            send.tahunPembuatan = 0;

            send.dokumen = this.rowsDokumenFasilitas;
            send.vd = this.rowsTransaksi;
            send.spek_khusus = this.rowsSpekKhusus;

            send.tarif = [];
            // var cif = this.formsBarang?.cifRupiah ? this.formsBarang.cifRupiah : 0;
            // var nilaiFasilitasPpn = 0;
            // var nilaiBayarPpn = 0;
            var nilaiImpor = this.cifRupiah;
            if (this.isBm) {
                var nilaiBm = 0;
                if (this.jenisFasilitasBm && this.jenisFasilitasBm?.code) {
                    nilaiBm = parseFloat(this.cifRupiah) * (parseFloat(this.formsPungutan.tarifBm) / 100);
                }
                console.log("Nilai BM", nilaiBm);

                var nilaiFasilitasBm = 0;
                var nilaiBayarBm = 0;

                if (this.jenisFasilitasBm && this.jenisFasilitasBm?.code !== "1") {
                    nilaiFasilitasBm = parseFloat(nilaiBm) * parseFloat(this.formsPungutan.tarifFasilitasbm / 100);
                    nilaiBayarBm = parseFloat(nilaiBm) * parseFloat((100 - this.formsPungutan.tarifFasilitasbm) / 100);
                } else {
                    nilaiBayarBm = parseFloat(nilaiBm) * parseFloat(this.formsPungutan.tarifFasilitasbm / 100);
                }
                nilaiImpor += nilaiBayarBm;
                // BM
                send.tarif.push({
                    kodeJenisTarif: this.jenisTarifBm?.code,
                    namaJenisTarif: this.jenisTarifBm?.name,
                    kodeFasilitasTarif: this.jenisFasilitasBm?.code,
                    namaFasilitasTarif: this.jenisFasilitasBm?.name,
                    kodeJenisPungutan: this.jenisPungutanBm?.code,
                    namaJenisPungutan: this.jenisPungutanBm?.code,
                    tarif: this.formsPungutan?.tarifBm,
                    tarifFasilitas: this.formsPungutan.tarifFasilitasbm,
                    nilaiFasilitas: nilaiFasilitasBm,
                    nilaiBayar: nilaiBayarBm,
                });
            }

            if (this.isBmAd) {

                var nilaiBmAd = 0;
                if (this.jenisFasilitasBmAd && this.jenisFasilitasBmAd?.code) {
                    nilaiBmAd = parseFloat(this.cifRupiah) * (parseFloat(this.formsPungutan.tarifAd) / 100);
                }
                console.log("Nilai BMAD", nilaiBmAd);

                var nilaiFasilitasBmAd = 0;
                var nilaiBayarBmAd = 0;

                if (this.jenisFasilitasBmAd && this.jenisFasilitasBmAd?.code !== "1") {
                    nilaiFasilitasBmAd = parseFloat(nilaiBmAd) * parseFloat(this.formsPungutan.tarifFasilitasAd / 100);
                    nilaiBayarBmAd = parseFloat(nilaiBmAd) * parseFloat((100 - this.formsPungutan.tarifFasilitasbm) / 100);
                } else {
                    nilaiBayarBmAd = parseFloat(nilaiBmAd) * parseFloat(this.formsPungutan.tarifFasilitasAd / 100);
                }
                nilaiImpor += nilaiBayarBmAd;
                // BMAD
                send.tarif.push({
                    kodeJenisPungutan: "BMAD",
                    namaJenisPungutan: "BMAD",
                    kodeJenisTarif: this.jenisTarifBmAd?.code,
                    namaJenisTarif: this.jenisTarifBmAd?.name,
                    kodeFasilitasTarif: this.jenisFasilitasBmAd?.code,
                    namaFasilitasTarif: this.jenisFasilitasBmAd?.name,
                    tarif: this.formsPungutan.tarifAd,
                    tarifFasilitas: this.formsPungutan.tarifFasilitasAd,
                    sementara: this.formsPungutan.checkBMAD,
                    nilaiFasilitas: nilaiFasilitasBmAd,
                    nilaiBayar: nilaiBayarBmAd,
                });
            }

            if (this.isBmTp) {

                var nilaiBmTp = 0;
                if (this.jenisFasilitasBmTp && this.jenisFasilitasBmTp?.code) {
                    nilaiBmTp = parseFloat(this.cifRupiah) * (parseFloat(this.formsPungutan.tarifTp) / 100);
                }
                console.log("Nilai BMTP", nilaiBmTp);

                var nilaiFasilitasBmTp = 0;
                var nilaiBayarBmTp = 0;

                if (this.jenisFasilitasBmTp && this.jenisFasilitasBmTp?.code !== "1") {
                    nilaiFasilitasBmTp = parseFloat(nilaiBmTp) * parseFloat(this.formsPungutan.tarifFasilitasTp / 100);
                    nilaiBayarBmTp = parseFloat(nilaiBmTp) * parseFloat((100 - this.formsPungutan.tarifFasilitasTp) / 100);
                } else {
                    nilaiBayarBmTp = parseFloat(nilaiBmTp) * parseFloat(this.formsPungutan.tarifFasilitasTp / 100);
                }
                nilaiImpor += nilaiBayarBmTp;

                // BMTP
                send.tarif.push({
                    kodeJenisPungutan: "BMTP",
                    namaJenisPungutan: "BMTP",
                    kodeJenisTarif: this.jenisTarifBmTp?.code,
                    namaJenisTarif: this.jenisTarifBmTp?.name,
                    kodeFasilitasTarif: this.jenisFasilitasBmTp?.code,
                    namaFasilitasTarif: this.jenisFasilitasBmTp?.name,
                    tarif: this.formsPungutan.tarifTp,
                    tarifFasilitas: this.formsPungutan.tarifFasilitasTp,
                    sementara: this.formsPungutan.checkBMTP,
                    nilaiFasilitas: nilaiFasilitasBmTp,
                    nilaiBayar: nilaiBayarBmTp,
                });
            }

            if (this.isBmIm) {
                var nilaiBmIm = 0;
                if (this.tarifFasilitasIm && this.tarifFasilitasIm?.code) {
                    nilaiBmIm = parseFloat(this.cifRupiah) * (parseFloat(this.formsPungutan.tarifIm) / 100);
                }
                console.log("Nilai BMIM", nilaiBmIm);

                var nilaiFasilitasBmIm = 0;
                var nilaiBayarBmIm = 0;

                if (this.jenisFasilitasBmIm && this.tarifFasilitasIm?.code !== "1") {
                    nilaiFasilitasBmIm = parseFloat(nilaiBmIm) * parseFloat(this.formsPungutan.tarifFasilitasIm / 100);
                    nilaiBayarBmIm = parseFloat(nilaiBmIm) * parseFloat((100 - this.formsPungutan.tarifFasilitasIm) / 100);
                } else {
                    nilaiBayarBmIm = parseFloat(nilaiBmIm) * parseFloat(this.formsPungutan.tarifFasilitasIm / 100);
                }
                nilaiImpor += nilaiBayarBmIm;

                // BMTP
                send.tarif.push({
                    kodeJenisPungutan: "BMIM",
                    namaJenisPungutan: "BMIM",
                    kodeJenisTarif: this.jenisTarifBmIm?.code,
                    namaJenisTarif: this.jenisTarifBmIm?.name,
                    kodeFasilitasTarif: this.jenisFasilitasBmIm?.code,
                    namaFasilitasTarif: this.jenisFasilitasBmIm?.name,
                    tarif: this.formsPungutan.tarifIm,
                    tarifFasilitas: this.formsPungutan.tarifFasilitasIm,
                    sementara: this.formsPungutan.checkBMIM,
                    nilaiFasilitas: nilaiFasilitasBmIm,
                    nilaiBayar: nilaiBayarBmIm,
                });
            }

            if (this.isCukai) {
                // Cukai
                send.tarif.push({
                    kodeJenisPungutan: "CUKAI",
                    namaJenisPungutan: "CUKAI",
                    kodeJenisTarif: this.jenisTarifCukai?.code,
                    namaJenisTarif: this.jenisTarifCukai?.name,
                    jumlahSatuan: this.formsBarang.jumlahSatuanCukai,
                    kodeFasilitasTarif: this.jenisFasilitasCukai?.code,
                    namaFasilitasTarif: this.jenisFasilitasCukai?.name,
                    tarif: this.formsBarang.tarifCukai,
                    // nilaiFasilitas: this.countPercentageCif(this.formsPungutan?.tarifIm),
                    // nilaiBayar: this.countPercentageCif(this.formsPungutan?.tarifIm) * parseFloat(this.formsPungutan.tarifFasilitasIm / 100),
                });
            }

            var nilaiPPN = 0;
            if (this.jenisFasilitasPpn && this.jenisFasilitasPpn?.code) {
                nilaiPPN = parseFloat(nilaiImpor) * (parseFloat(this.formsPungutan.tariffPpn) / 100);
            }
            var nilaiFasilitasPPN = 0;
            var nilaiBayarPPN = 0;
            if (this.jenisFasilitasPpn && this.jenisFasilitasPpn?.code !== "1") {
                nilaiFasilitasPPN = parseFloat(nilaiPPN) * parseFloat(this.formsPungutan.tariffFasilitasPpn / 100);
                nilaiBayarPPN = parseFloat(nilaiPPN) * parseFloat((100 - this.formsPungutan.tariffFasilitasPpn) / 100);
            } else {
                nilaiBayarPPN = parseFloat(nilaiPPN) * parseFloat(this.formsPungutan.tariffFasilitasPpn / 100);
            }


            console.log("Nilai PPN", nilaiPPN);

            send.tarif.push({
                kodeFasilitasTarif: this.jenisFasilitasPpn?.code,
                namaFasilitasTarif: this.jenisFasilitasPpn?.name,
                kodeJenisPungutan: "PPN",
                namaJenisPungutan: "PPN",
                tarif: this.formsPungutan?.tariffPpn,
                kodeJenisTarif: "1",
                namaJenisTarif: "ADVALORUM",
                tarifFasilitas: this.formsPungutan.tariffFasilitasPpn,
                nilaiFasilitas: Math.floor(nilaiFasilitasPPN),
                nilaiBayar: Math.floor(nilaiBayarPPN),
            });

            var nilaiPPH = 0;

            if (this.jenisFasilitasPph && this.jenisFasilitasPph?.code) {
                let nilaiImporBulet = Math.floor((parseFloat(nilaiImpor)/1000))*1000;
                nilaiPPH = parseFloat(nilaiImporBulet) * (parseFloat(this.formsPungutan.tariffPph) / 100);
            }

            var nilaiFasilitasPPH = 0;
            var nilaiBayarPPH = 0;

            if (this.jenisFasilitasPph && this.jenisFasilitasPph?.code !== "1") {
                nilaiFasilitasPPH = parseFloat(nilaiPPH) * parseFloat(this.formsPungutan.tariffFasilitasPph / 100);
                nilaiBayarPPH = parseFloat(nilaiPPH) * parseFloat((100 - this.formsPungutan.tariffFasilitasPph) / 100);
            } else {
                nilaiBayarPPH = parseFloat(nilaiPPH) * parseFloat(this.formsPungutan.tariffFasilitasPph / 100);
            }

            console.log("Nilai PPH", nilaiPPH);

            send.tarif.push({
                kodeFasilitasTarif: this.jenisFasilitasPph?.code,
                namaFasilitasTarif: this.jenisFasilitasPph?.name,
                kodeJenisPungutan: "PPH",
                namaJenisPungutan: "PPH",
                kodeJenisTarif: "1",
                namaJenisTarif: "ADVALORUM",
                tarif: this.formsPungutan?.tariffPph,
                tarifFasilitas: this.formsPungutan.tariffFasilitasPph,
                nilaiFasilitas: nilaiFasilitasPPH,
                nilaiBayar: nilaiBayarPPH,
            });
            if (!this.isUpdate) {
                this.addData(send);
            } else {
                this.updateData(send, send.document_barang_id)
            }

        },

        addData(send) {
            const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-8-barang";

            return this.$http
                .post(
                    baseURI, send, { timeout: 100000 }
                )
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                        this.isLoading = false;
                        this.errors = [];
                        this.success("Data Berhasil Disimpan")
                        this.$emit("changeBarang");
                        this.$emit("showForm");
                    } else {
                        this.isLoading = false;
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.loading();

                    if (error.response.data.status == 422) {
                        this.isLoading = false;
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else {
                        if (error.code == "ECONNABORTED") {
                            this.error("Please Check Your Internet Connection");
                        }
                    }

                });
        },

        updateData(send, id) {
            const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-8-update-barang/" + id;

            return this.$http
                .patch(
                    baseURI, send, { timeout: 100000 }
                )
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                        this.isLoading = false;
                        this.errors = [];
                        this.success("Data Berhasil Disimpan")
                        this.$emit("changeBarang");
                        this.$emit("showForm");
                    } else {
                        this.isLoading = false;
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.loading();
                    if (error.response.data.status == 422) {
                        this.isLoading = false;
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else {
                        if (error.code == "ECONNABORTED") {
                            this.error("Please Check Your Internet Connection");
                        }
                    }

                });
        },

        removeRowFasilitas(index) {
            this.rowsDokumenFasilitas.splice(index, 1);
        },
        removeRowTransaksi(index) {
            this.rowsTransaksi.splice(index, 1);
        },
        removeRowSpekKhusus(index) {
            this.rowsSpekKhusus.splice(index, 1);
        },
        showForm() {
            this.$emit("showForm");
        },
        addRowFasilitas() {
            this.$modal.show('DocumentListFasilitas');
        },
        addRowTransaksi() {
            this.$modal.show('DocumentJenisTransaksi');
        },
        addRowSpekKhusus() {
            this.$modal.show('DocumentSpekKhusus');
        },
        reAssignValue(val) {
            console.log(val);
            if (val) {

                var vd = val.vd;
                var tempTransaksi = [];
                if (vd && vd.length > 0) {
                    vd.forEach(function (val) {
                        console.log(val);
                        var code = val?.kodeJenisVd ? val.kodeJenisVd : "";
                        var name = val?.namaJenisVd ? val.namaJenisVd : "";
                        tempTransaksi.push({
                            kodeJenisVd: code,
                            namaJenisVd: name,
                            jenisTransaksi: code + " - " + name,
                            jatuhTempo: val.jatuhTempo,
                            nilaiBarangVd: val?.nilaiBarangVd,
                        });
                    });
                }
                this.rowsTransaksi = tempTransaksi;

                var dokumen = val.dokumen;
                var tempDokumen = [];

                if (dokumen && dokumen.length > 0) {
                    dokumen.forEach(function (ob) {
                        tempDokumen.push({
                            "document_dokumen_id": ob.document_dokumen_id,
                            "document_id": ob.dokumen_detail.document_id,
                            "document": ob.dokumen_detail.kodeDokumen + " - " + ob.dokumen_detail.namaDokumen,
                            "fasilitas": ob.dokumen_detail.kodeFasilitas + " - " + ob.dokumen_detail.namaFasilitas,
                            "deskripsiIjin": ob?.deskripsiIjin ? ob.deskripsiIjin : "-",
                            "nomorDokumen": ob.dokumen_detail.nomorDokumen,
                            "tanggalDokumen": ob.dokumen_detail.tanggalDokumen,
                            "seriDokumen": ob.dokumen_detail.seriDokumen,
                            "urlDokumen": ob.dokumen_detail.urlDokumen,
                        })
                    });
                }
                this.rowsDokumenFasilitas = tempDokumen;

                var spekKhusus = val.spek_khusus;
                var tempSpekKhusus = [];

                if(spekKhusus && spekKhusus.length > 0){
                    spekKhusus.forEach(function(val){
                        var code = val?.kodeSpekKhusus ? val.kodeSpekKhusus : "";
                        var name = val?.namaSpekKhusus ? val.namaSpekKhusus : "";
                        tempSpekKhusus.push({
                            kodeSpekKhusus:code,
                            namaSpekKhusus:name,
                            spekKhusus: code + " - "+name,
                            uraianSpekKhusus:val?.uraianSpekKhusus
                        });
                    });
                }
                this.rowsSpekKhusus = tempSpekKhusus;


                this.formsBarang = {
                    document_barang_id: val.document_barang_id,
                    netto: val?.netto ? val.netto : 0,
                    jumlahSatuan: val?.jumlahSatuan ? val.jumlahSatuan : 0,
                    jumlahKemasan: val?.jumlahKemasan ? val.jumlahKemasan : 0,
                    nilaiBarang: val?.nilaiBarang ? val.nilaiBarang : 0,
                    tarifCukai: val?.tarifCukai ? val.tarifCukai : 0,
                    jumlahSatuanCukai: val?.jumlahSatuanCukai ? val.jumlahSatuanCukai : 0,
                    nilaiCukai: val?.nilaiCukai ? val.nilaiCukai : 0,
                    hjeCukai: val?.hjeCukai ? val.hjeCukai : 0,
                    kemasanCukai: 0,
                    isiPerKemasan: val?.isiPerKemasan ? val.isiPerKemasan : 0,
                    jumlahPitaCukai: val?.jumlahPitaCukai ? val.jumlahPitaCukai : 0,
                    saldoAwal: val?.saldoAwal ? val.saldoAwal : 0,
                    saldoAkhir: val?.saldoAkhir ? val.saldoAkhir : 0,

                    pernyataanLartas: val.pernyataanLartas,
                    uraian: val.uraian,
                    merk: val.merk,
                    tipe: val.tipe,
                    ukuran: val.ukuran,
                    kode: val.kode,
                    spesifikasiLain: val.spesifikasiLain,
                    // fob: val.fob,
                    // hargaSatuan: val.hargaSatuan,
                    // freight: val.freight,
                    // asuransi: val.asuransi,
                    // cifRupiah: val.cifRupiah,
                    nilaiBayar: 0,
                };
                this.isLartas = val.flagLantas ? true : false;
                this.kemasanBarang = {
                    code: val.kodeJenisKemasan,
                    name: val.namaJenisKemasan,
                    label: val.kodeJenisKemasan + " - " + val.namaJenisKemasan
                }
                this.kondisiBarang = {
                    code: val.kodeKondisiBarang,
                    name: val.namaKondisiBarang,
                    label: val.kodeKondisiBarang + " - " + val.namaKondisiBarang
                }
                this.negaraAsal = {
                    code: val.kodeNegaraAsal,
                    name: val.namaNegaraAsal,
                    label: val.kodeNegaraAsal + " - " + val.namaNegaraAsal
                }
                this.satuanBarang = {
                    code: val.kodeSatuanBarang,
                    name: val.namaSatuanBarang,
                    label: val.kodeSatuanBarang + " - " + val.namaSatuanBarang
                }

                this.HsCode = {
                    hs_code: val.hsCode,
                    uraian: val.hsCodeUraian,
                    hs_code_format: val.hsCode,
                    label: val.hsCode + " - " + val.hsCodeUraian
                }

                var tarif = val.tarif;

                if (tarif && tarif.length > 0) {
                    tarif.forEach(item => {

                        if (item.kodeJenisPungutan == "BM" || item.kodeJenisPungutan == "BMKITE") {
                            this.isBm = true;
                            this.jenisTarifBm = {
                                "code": item.kodeJenisTarif,
                                "name": item.namaJenisTarif,
                                "label": item.kodeJenisTarif + " - " + item.namaJenisTarif,
                            };
                            this.jenisFasilitasBm = {
                                "code": item.kodeFasilitasTarif,
                                "name": item.namaFasilitasTarif,
                                "label": item.kodeFasilitasTarif + " - " + item.namaFasilitasTarif,
                            };

                            this.jenisPungutanBm = {
                                "code": item.kodeJenisPungutan,
                                "name": item.namaJenisPungutan,
                                "label": item.kodeJenisPungutan + " - " + item.namaJenisPungutan,
                            };

                            this.$set(this.formsPungutan, "tarifBm", item.tarif);
                            this.$set(this.formsPungutan, "tarifFasilitasbm", item.tarifFasilitas);

                        }

                        if (item.kodeJenisPungutan == "PPN") {
                            this.jenisFasilitasPpn = {
                                "code": item.kodeFasilitasTarif,
                                "name": item.namaFasilitasTarif,
                                "label": item.kodeFasilitasTarif + " - " + item.namaFasilitasTarif,
                            };
                            this.$set(this.formsPungutan, "tariffPpn", item.tarif);
                            this.$set(this.formsPungutan, "tariffFasilitasPpn", item.tarifFasilitas);
                        }

                        if (item.kodeJenisPungutan == "PPH") {
                            this.jenisFasilitasPph = {
                                "code": item.kodeFasilitasTarif,
                                "name": item.namaFasilitasTarif,
                                "label": item.kodeFasilitasTarif + " - " + item.namaFasilitasTarif,
                            };
                            this.$set(this.formsPungutan, "tariffPph", item.tarif);
                            this.$set(this.formsPungutan, "tariffFasilitasPph", item.tarifFasilitas);
                        }

                        if (item.kodeJenisPungutan == "BMAD") {
                            this.isBmAd = true;
                            this.jenisTarifBmAd = {
                                "code": item.kodeJenisTarif,
                                "name": item.namaJenisTarif,
                                "label": item.kodeJenisTarif + " - " + item.namaJenisTarif,
                            };
                            this.jenisFasilitasBmAd = {
                                "code": item.kodeFasilitasTarif,
                                "name": item.namaFasilitasTarif,
                                "label": item.kodeFasilitasTarif + " - " + item.namaFasilitasTarif,
                            };


                            this.$set(this.formsPungutan, "tarifAd", item.tarif);
                            this.$set(this.formsPungutan, "tarifFasilitasAd", item.tarifFasilitas);

                            if (item.semetara == 1) {
                                this.$set(this.formsPungutan, "checkBMAD", true);
                            } else {
                                this.$set(this.formsPungutan, "checkBMAD", false);
                            }
                        }
                        if (item.kodeJenisPungutan == "BMTP") {
                            this.isBmTp = true;
                            this.jenisTarifBmTp = {
                                "code": item.kodeJenisTarif,
                                "name": item.namaJenisTarif,
                                "label": item.kodeJenisTarif + " - " + item.namaJenisTarif,
                            };
                            this.jenisFasilitasBmTp = {
                                "code": item.kodeFasilitasTarif,
                                "name": item.namaFasilitasTarif,
                                "label": item.kodeFasilitasTarif + " - " + item.namaFasilitasTarif,
                            };


                            this.$set(this.formsPungutan, "tarifTp", item.tarif);
                            this.$set(this.formsPungutan, "tarifFasilitasTp", item.tarifFasilitas);

                            if (item.semetara == 1) {
                                this.$set(this.formsPungutan, "checkBMTP", true);
                            } else {
                                this.$set(this.formsPungutan, "checkBMTP", false);
                            }
                        }
                        if (item.kodeJenisPungutan == "BMIM") {
                            this.isBmIm = true;
                            this.jenisTarifBmIm = {
                                "code": item.kodeJenisTarif,
                                "name": item.namaJenisTarif,
                                "label": item.kodeJenisTarif + " - " + item.namaJenisTarif,
                            };
                            this.jenisFasilitasBmIm = {
                                "code": item.kodeFasilitasTarif,
                                "name": item.namaFasilitasTarif,
                                "label": item.kodeFasilitasTarif + " - " + item.namaFasilitasTarif,
                            };


                            this.$set(this.formsPungutan, "tarifIm", item.tarif);
                            this.$set(this.formsPungutan, "tarifFasilitasIm", item.tarifFasilitas);

                            if (item.semetara == 1) {
                                this.$set(this.formsPungutan, "checkBMIM", true);
                            } else {
                                this.$set(this.formsPungutan, "checkBMIM", false);
                            }
                        }
                        if (item.kodeJenisPungutan == "CUKAI") {
                            this.isBmIm = true;
                            this.jenisTarifCukai = {
                                "code": item.kodeJenisTarif,
                                "name": item.namaJenisTarif,
                                "label": item.kodeJenisTarif + " - " + item.namaJenisTarif,
                            };
                            this.jenisFasilitasCukai = {
                                "code": item.kodeFasilitasTarif,
                                "name": item.namaFasilitasTarif,
                                "label": item.kodeFasilitasTarif + " - " + item.namaFasilitasTarif,
                            };


                            this.$set(this.formsBarang, "tarifCukai", item.tarif);
                            this.$set(this.formsBarang, "jumlahSatuanCukai", item.jumlahSatuan);

                        }
                    });
                }
                if(this.formType == 'copy'){
                    this.isUpdate = false;
                }else{
                    this.isUpdate = true;
                }
            } else {
                this.isUpdate = false;
            }
        },
        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },
        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;

            let rolePermision = [];

            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'CeisaBarangImporController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;

            this.loadFilterType();
            this.loading();

        },


        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },
        async checkStatus(ev) {
            if (ev == "create") {
                this.rowsDokumenFasilitas = [];
                this.rowsTransaksi = [];
                this.HsCode = null;
                this.kondisiBarang = null;
                this.negaraAsal = null;
                this.satuanBarang = null;
                this.satuanCukai = null;
                this.kemasanBarang = null;
                this.kemasanCukai = null;
                this.jenisTarifBm = null;
                this.jenisTarifCukai = null;
                this.jenisTarifBmAd = null;
                this.jenisTarifBmTp = null;
                this.jenisTarifBmIm = null;
                this.jenisFasilitasBm = null;
                this.jenisFasilitasPpn = null;
                this.jenisFasilitasPph = { "code": "1", "name": "DIBAYAR", "label": "1 - DIBAYAR" };
                this.jenisFasilitasCukai = null;
                this.jenisFasilitasBmAd = null;
                this.jenisFasilitasBmTp = null;
                this.jenisFasilitasBmIm = null;
                this.komoditiCukai = null;
                this.isUpdate = false;
                this.isLartas = null;
                this.isCukai = null;
                this.isBm = null;
                this.isBmAd = null;
                this.isBmTp = null;
                this.isBmIm = null;

                this.formsBarang = {
                    jumlahSatuan: 0,
                    jumlahKemasan: 0,
                    nilaiBarang: 0,

                    kemasanCukai: 0,
                    nilaiCukai: 0,
                    jumlahSatuanCukai: 0,
                    tarifCukai: 0,
                    isiPerKemasan: 0,
                    jumlahPitaCukai: 0,
                    saldoAwal: 0,
                    saldoAkhir: 0,
                    hjeCukai: 0,

                    netto: 0,

                    freight: 0,
                    asuransi: 0,
                    cif: 0,
                    cifRupiah: 0,
                };

                this.formsPungutan = {
                    tarifBm: 0,
                    tarifAd: 0,
                    tarifTp: 0,
                    tarifIm: 0,
                    tarifFasilitasbm: 0,
                    tariffPpn: 0,
                    tariffPph: 0,
                    tariffFasilitasPpn: 0,
                    tariffFasilitasPph: 100,
                    tarifFasilitasAd: 0,
                    tarifFasilitasTp: 0,
                    tarifFasilitasIm: 0,
                    checkBMAD: false,
                    checkBMTP: false,
                    checkBMIM: false,

                };
            }

        },

        async checkKurs(ev) {
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=1&page=1&status=active&type=kurs&code=" + ev;
            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;
                    var val = 0;
                    if (models.length > 0) {
                        val = parseFloat(models[0].name);
                    } else {
                        val = 0;
                    }
                    return val;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }
                    return 0;

                });
        }

    },
    watch: {
        propsData: function (newVal) {
            this.forms = newVal;
            this.documents = newVal.dokumen;
            this.checkStatus(newVal);
        },
        propsBarang: function (newVal) {
            this.reAssignValue(newVal);

        },
        forms: function (newVal) {
            this.$emit('formUpdate', newVal);
        },
        formType: function (newVal) {
            this.checkStatus(newVal);
        }
    },
    computed: {
        cif() {
            var a = 0;
            a += this.getTotalVd;
            a += this.fob;
            a += this.freight;
            a += this.asuransi;
            return a;
        },
        cifRupiah() {
            var a = 0;
            a = parseFloat(this.cif) * parseFloat(this.forms.ndpbm);
            return a;

        },
        getTotalVd() {
            var a = 0;
            this.rowsTransaksi.forEach(el => {
                a += el.nilaiBarangVd
            });

            return a;
        },
        fob() {
            return parseFloat(this.formsBarang.nilaiBarang) + parseFloat(this.biayaPengurang);
        },
        hargaSatuan() {
            var val = 0;
            if (this.formsBarang.jumlahSatuan && this.formsBarang.jumlahSatuan > 0 && this.fob && this.fob > 0) {
                val = this.fob / this.formsBarang.jumlahSatuan;
            }

            return val;
        },
        percentageAmount() {
            var a = 0;
            if (this.forms.nilaiIncoterm) {
                a = this.formsBarang.nilaiBarang / this.forms.nilaiIncoterm;
            }

            return a;
        },
        biayaPengurang() {
            var a = 0;
            if (this.percentageAmount > 0) {
                var biaya = parseFloat(this.forms.biayaTambahan) - parseFloat(this.forms.biayaPengurang);
                a = this.percentageAmount * biaya;
            }
            return a;
        },
        freight() {
            var a = 0;
            if (this.percentageAmount > 0) {
                a = this.percentageAmount * this.forms?.freight;
            }
            return a;
        },
        asuransi() {
            var a = 0;
            if (this.percentageAmount > 0) {
                a = this.percentageAmount * this.forms?.asuransi;
            }
            return a;
        },
    },
    created() {
        this.asyncNegaraAsal();
        this.asyncKondisiBarang();
        this.asyncHsCode();
        this.asyncSatuanBarang();
        this.asyncKemasanBarang();
        this.asyncFasilitas();
        this.asyncKomoditi();

    }
}
</script>

<style></style>